import { createAction, props } from '@ngrx/store';

import {
  ChangePasswordParams,
  UserInformation,
} from 'app/settings/account-settings/account-settings.model';
import * as CONST from './account-settings.store.const';

const accountKey = '[Account Settings]';

export const changePassword = createAction(
  CONST.CHANGE_PASSWORD,
  props<{ passwordData: ChangePasswordParams }>(),
);
export const changePasswordSuccess = createAction(CONST.CHANGE_PASSWORD_SUCCESS);
export const changePasswordFailed = createAction(CONST.CHANGE_PASSWORD_FAILED);
export const refreshUserData = createAction(CONST.UPDATE_ACCOUNT_SETTINGS);
export const refreshUserDataSuccess = createAction(
  CONST.UPDATE_ACCOUNT_SETTINGS_SUCCESS,
  props<{ payload: UserInformation }>(),
);
export const refreshUserDataFailed = createAction(CONST.UPDATE_ACCOUNT_SETTINGS_FAIL);
export const updateUserInfo = createAction(
  CONST.UPDATE_USER_INFO,
  props<{ userSettingsData: UserInformation }>(),
);
export const updateUserInfoSuccess = createAction(
  CONST.UPDATE_USER_INFO_SUCCESS,
  props<{ payload: UserInformation }>(),
);
export const updateUserInfoFailed = createAction(
  CONST.UPDATE_USER_INFO_FAIL,
  props<{ errors: any }>(),
);
export const updateNotifications = createAction(
  CONST.UPDATE_NOTIFICATIONS,
  props<{ payload: boolean }>(),
);
export const updateNotificationsSuccess = createAction(
  CONST.UPDATE_NOTIFICATIONS_SUCCESS,
  props<{ payload: boolean }>(),
);
export const updateNotificationsFailed = createAction(
  CONST.UPDATE_NOTIFICATIONS_FAIL,
  props<{ errors: any }>(),
);
export const initUserDataAfterLogin = createAction(`${accountKey} init user data after login`);
export const initUserDataAfterLoginSuccess = createAction(
  `${accountKey} init user data after login success`,
  props<{ payload: UserInformation }>(),
);
export const initUserDataAfterLoginFail = createAction(
  `${accountKey} init user data after login fail`,
);
